import { useMemo } from 'react';
import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { defaultSettings, meta } from '../../constants';
import { ChatWindow } from './chat';
import {
  ActionBlock,
  Close,
  Deactivation,
  Header,
  StyledFreeLink
} from './components';
import { backgroundPatterns } from './options';
import { variants } from './variants';

export const Window = () => {
  const {
    position,
    chatWallpaperMulticolor,
    renderThumbnailMode,
    chatWallpaper = defaultSettings.chatWallpaper
  } = useSettings();

  const WindowLayout = variants[position];

  const backgroundStyle = useMemo(() => {
    if (['whatsapp', 'line', 'telegram'].includes(meta.provider)) {
      return chatWallpaperMulticolor?.type === 'native'
        ? `url(${backgroundPatterns[meta.provider]})`
        : chatWallpaperMulticolor?.color;
    }

    return chatWallpaper;
  }, [chatWallpaperMulticolor, chatWallpaper]);

  return (
    <Container>
      <WindowLayout>
        <Content _thumbnailMode={renderThumbnailMode}>
          <Deactivation />
          {/*{position === 'embed-chat' && <Deactivation />}*/}
          {position !== 'embed-chat' && <Close />}
          <Header />
          <ChatGroup _background={backgroundStyle}>
            <ChatWindow />

            <ActionBlock />
            <StyledFreeLink background={backgroundStyle} />
          </ChatGroup>
        </Content>
      </WindowLayout>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const Content = styled.div<{ _thumbnailMode?: boolean }>`
  border-radius: 16px;
  overflow: hidden;
  position: relative;

  box-shadow: ${({ _thumbnailMode }) =>
    _thumbnailMode
      ? '0 6px 50px 0 rgba(0, 0, 0, 0.1)'
      : '0 4px 30px 0 rgba(0, 0, 0, 0.3)'};
`;

const ChatGroup = styled.div<{ _background?: string }>`
  background: ${({ _background }) => _background} center / cover no-repeat;
`;
